import o from "./ghl-ui.es419.js";
import i from "./ghl-ui.es1199.js";
import m from "./ghl-ui.es1485.js";
import f from "./ghl-ui.es1291.js";
function c(r, t) {
  return o(r) ? r : i(r, t) ? [r] : m(f(r));
}
export {
  c as default
};
